<template>
  <AppSection top>
    <AppContainer>
      <BlogHero />
      <AppRow wide unwrapped>
        <AppCol v-if="desktop">
          <BlogCategories variant="links" titled />
        </AppCol>
        <AppCol :cols="9">
          <LoadingSpinner v-if="status == 'pending'" />
          <div v-else-if="posts">
            <ArticleSearch v-model="search" @submit="execute" />
            <MobileOnly>
              <v-expansion-panels class="mt-6" flat eager>
                <v-expansion-panel>
                  <v-expansion-panel-title>
                    <h4 class="mb-0">{{ $tt('blog.categories') }}</h4>
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <BlogCategories variant="links" />
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </MobileOnly>
            <ArticleCards :posts has-excerpt />
          </div>
        </AppCol>
      </AppRow>
    </AppContainer>
  </AppSection>
</template>

<script lang="ts" setup>
import { getCurrentYear } from '~/helpers/date';

const { tt } = useLocalization();
const currentYear = getCurrentYear();

usePageHead({
  title: tt('blog.title'),
  description: tt('blog.meta_desc', { currentYear }),
  image: {
    src: '/images/desk.webp',
    alt: tt('blog.blog'),
    width: 496,
    height: 750
  },
  alternateBranches: 'all'
});
useSchemaOrg('blog');

const { desktop } = useBreakpoints();

const search = ref('');
const { getPosts } = useWordpress();
const { data: posts, status, execute } = useAsyncData('posts', () => getPosts({ search: search.value }));
</script>

<style scoped>
p {
  line-height: var(--lh-md);
}

@media (max-width: 850px) {
  h2 {
    padding-bottom: var(--space-5) !important;
    text-align: center;
  }
  p {
    padding-bottom: var(--space-6) !important;
    text-align: center;
  }
  .v-expansion-panel-title, :deep(.v-expansion-panel-text__wrapper) {
    padding: 0 var(--space-2) !important;
  }
  .cards {
    padding-top: var(--space-4) !important;
  }
}
</style>